module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.3065/img/gold-tier-icon.svg"